var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"surround-box"},[_c('span',{staticClass:"left-top surround-box-left-top"}),_c('span',{staticClass:"left-bottom surround-box-left-bottom"}),_c('span',{staticClass:"right-top surround-box-right-top"}),_c('span',{staticClass:"right-bottom surround-box-right-bottom"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }